import { api } from '../main-api/apiClient';

// Tenant Nurse API services - for patient care and monitoring
export const tenantNurseAPI = {
  // Patient Management - Now optimized to prevent 504 timeouts
  getPatients: () => {
    console.log('=== FRONTEND: tenantNurseAPI.getPatients called ===');
    try {
      return api.get('/tenant-nurse/patients');
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.getPatients failed ===');
      console.error('Error:', error);
      throw error;
    }
  },
  
  getPatientDetails: (patientId) => {
    console.log('=== FRONTEND: tenantNurseAPI.getPatientDetails called ===');
    console.log('Patient ID:', patientId);
    try {
      return api.get(`/tenant-nurse/patients/${patientId}`);
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.getPatientDetails failed ===');
      console.error('Error:', error);
      console.error('Patient ID:', patientId);
      throw error;
    }
  },
  
  // Care Notes Management
  addCareNotes: (patientId, careNotes, careType) => {
    console.log('=== FRONTEND: tenantNurseAPI.addCareNotes called ===');
    console.log('Patient ID:', patientId);
    console.log('Care type:', careType);
    console.log('Care notes length:', careNotes ? careNotes.length : 0);
    
    try {
      const formData = new FormData();
      formData.append('care_notes', careNotes);
      formData.append('care_type', careType);
      console.log('Form data prepared, making API call...');
      return api.post(`/tenant-nurse/patients/${patientId}/care-notes`, formData);
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.addCareNotes failed ===');
      console.error('Error:', error);
      console.error('Patient ID:', patientId);
      console.error('Care type:', careType);
      throw error;
    }
  },
  
  // Recording Management (nurses can also send recording links)
  sendRecordingLink: (patientId, channel, customMessage = null) => {
    console.log('=== FRONTEND: tenantNurseAPI.sendRecordingLink called ===');
    console.log('Patient ID:', patientId);
    console.log('Channel:', channel);
    console.log('Custom message:', customMessage ? 'Yes' : 'No');
    
    try {
      const formData = new FormData();
      formData.append('channel', channel);
      if (customMessage && customMessage.trim()) {
        formData.append('custom_message', customMessage);
      }
      console.log('Form data prepared, making API call...');
      return api.post(`/tenant-nurse/patients/${patientId}/send-recording-link`, formData);
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.sendRecordingLink failed ===');
      console.error('Error:', error);
      console.error('Patient ID:', patientId);
      console.error('Channel:', channel);
      throw error;
    }
  },
  
  // Dashboard and Analytics
  getDashboardSummary: () => {
    console.log('=== FRONTEND: tenantNurseAPI.getDashboardSummary called ===');
    try {
      return api.get('/tenant-nurse/dashboard/summary');
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.getDashboardSummary failed ===');
      console.error('Error:', error);
      throw error;
    }
  },
  
  getCriticalAlerts: () => {
    console.log('=== FRONTEND: tenantNurseAPI.getCriticalAlerts called ===');
    try {
      return api.get('/tenant-nurse/dashboard/critical-alerts');
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.getCriticalAlerts failed ===');
      console.error('Error:', error);
      throw error;
    }
  },
  
  // Patient Monitoring
  getPatientVitals: (patientId) => {
    console.log('=== FRONTEND: tenantNurseAPI.getPatientVitals called ===');
    console.log('Patient ID:', patientId);
    try {
      return api.get(`/patients/${patientId}/vitals`);
    } catch (error) {
      console.error('=== FRONTEND: tenantNurseAPI.getPatientVitals failed ===');
      console.error('Error:', error);
      console.error('Patient ID:', patientId);
      throw error;
    }
  }
};

export default tenantNurseAPI;